import type { CalculatorInputs, CalculatorResults } from '@/lib/calculator'

interface Props {
  inputs: CalculatorInputs
  results: CalculatorResults
}

export default function PrintableChecklist({ inputs, results }: Props) {
  return (
    <div className="hidden print:block p-8 font-sans text-black">
      <h1 className="text-2xl font-bold mb-1">Wedding Alcohol Shopping List</h1>
      <p className="text-sm mb-4">
        {inputs.guestCount} guests · {inputs.hours} hours · {inputs.drinkingPercent}% drinking
      </p>
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="border-b border-black">
            <th className="text-left py-1">Item</th>
            <th className="text-left py-1">Quantity</th>
            <th className="text-left py-1">Est. Cost</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b border-gray-300">
            <td className="py-1">Wine (Red)</td>
            <td className="py-1">{results.redWineBottles} bottles</td>
            <td className="py-1">-</td>
          </tr>
          <tr className="border-b border-gray-300">
            <td className="py-1">Wine (White/Rosé)</td>
            <td className="py-1">{results.whiteWineBottles} bottles</td>
            <td className="py-1">${results.wineCost}</td>
          </tr>
          <tr className="border-b border-gray-300">
            <td className="py-1">Beer</td>
            <td className="py-1">{results.beerServings} cans/bottles ({results.beerCases} cases)</td>
            <td className="py-1">${results.beerCost}</td>
          </tr>
          <tr className="border-b border-gray-300">
            <td className="py-1">Spirits</td>
            <td className="py-1">{results.spiritBottles} bottles (750ml)</td>
            <td className="py-1">${results.spiritCost}</td>
          </tr>
          <tr className="border-b border-gray-300">
            <td className="py-1">Champagne (Toast)</td>
            <td className="py-1">{results.champagneBottles} bottles</td>
            <td className="py-1">${results.champagneCost}</td>
          </tr>
          <tr className="border-b border-gray-300">
            <td className="py-1">Mixers & Soda</td>
            <td className="py-1">{results.mixerLiters} liters</td>
            <td className="py-1">-</td>
          </tr>
          <tr className="border-b border-gray-300">
            <td className="py-1">Ice</td>
            <td className="py-1">{results.iceLbs} lbs ({results.iceBags} bags)</td>
            <td className="py-1">-</td>
          </tr>
        </tbody>
      </table>
      <p className="mt-4 font-semibold">
        Total Drinks: {results.totalDrinks} | Estimated Total Cost: ${results.costLow}-${results.costHigh}
      </p>
      <p className="mt-6 text-xs text-gray-500">Generated by weddingalcoholcalculator.com</p>
    </div>
  )
}
